/**
 * Pure data model for the redesigned Cash Runway card (dashboards round 2,
 * part 1d), shared between the Overall dashboard (group scope) and the
 * entity/Personal dashboard.
 *
 * Every figure comes from GET /dashboard/cash-runway (routes/dashboard.py
 * get_cash_runway), already scope-parameterized and already computing
 * year-to-date complete-month average net cashflow (intercompany excluded) -- no
 * re-derivation here, just picking the headline state and formatting inputs.
 *
 * currentCash is passed in by the caller as the SAME figure the Bank Balance
 * stat card shows (not cashRunway.cash_now, a separately-computed figure),
 * so the "current cash" subline reconciles to that card by construction.
 */

const MONTH_NAMES_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const CASH_RUNWAY_METHOD_TEXT =
  'Current cash divided by average monthly net cashflow, this year\'s complete months (same figure as Avg Net Cashflow).';

/**
 * @param {object} cashRunway - GET /dashboard/cash-runway response
 * @param {number} currentCash - the Bank Balance card's headline figure
 * @param {Date} [refDate] - injectable "today" for the until-date (tests)
 */
export function computeCashRunwayCard(cashRunway, currentCash, refDate) {
  const cr = cashRunway || {};
  const cashPositive = !!cr.cash_positive;
  const runwayMonths = cr.runway_months;
  const avgMonthlyNet = parseFloat(cr.avg_monthly_net ?? 0);
  const now = refDate || new Date();

  let untilLabel = null;
  if (!cashPositive && runwayMonths != null) {
    const until = new Date(now.getFullYear(), now.getMonth() + Math.round(runwayMonths), 1);
    untilLabel = `${MONTH_NAMES_SHORT[until.getMonth()]} ${until.getFullYear()}`;
  }

  return {
    cashPositive,
    runwayMonths: runwayMonths ?? null,
    untilLabel,
    currentCash: currentCash ?? 0,
    avgMonthlyNet,
    // Straight passthrough of the endpoint's own count -- no re-derivation.
    icExcludedCount: cr.ic_excluded_count || 0,
    methodText: CASH_RUNWAY_METHOD_TEXT,
  };
}
